//!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
  isLoading: false,

  // uyeler
  coopMemberList: [],
  coopMemberListCount: null,
  uyeMeslekiYeterlilik: null,
  uyeItemData: null,
  uyePiyasaBilgisi: null,
  uyeIsvereni: null,
  aracYetkiBelgeSorgu: null,
  aracItemData: null,

  coopAracList:[],
  coopAracListCount:null,

  isLoadingGetUyeMeslekiYeterlilik: null,
  isLoadingPiyasaBilgisiGetir: null,
  isLoadingGetUyeninBagliOlduguUyeler: null,

  isLoadingGetAracYetkiSorgu: null,
  isLoadingGetAracMuayeneSorgu: null,
  isLoadingGetAracCezaSorgu: null,
  isError: false,
  message: null,

  responseMessageList:[],
  topluAracEklemeHatalar:[],


  isLoadingAddCoop:false,
  isErrorAddCoop:false,
  isLoadingGetCoop:false,
  isErrorGetCoop:false,
  isLoadingUpdateCoop:false,
  isErrorUpdateCoop:false,
  isLoadingGetCoopExcel:false,
  isLoadingAddCoopExcel:false,
  isLoadingUyeDoc:false,
  isSuccessUyeDoc:false,

  isLoadingGetArac:false,
  isLoadingAddArac:false,
};


export const getUyeninBagliOlduguUyeler = createAsyncThunk( "uyelerAraclar/getUyeninBagliOlduguUyeler", async (id, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/user/BaglıOlduguUyeleriGor?id=${id}`);
      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg:
            error.response.data.error.errors.$values[0] ||
            "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
          resultType: "error",
          btnText1: "Listeye Dön",
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getUyeMeslekiYeterlilik = createAsyncThunk( "uyelerAraclar/getUyeMeslekiYeterlilik", async (userTC, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/user/UserMeslekiYeterlilikSorgula?Tckn=${userTC}`);
      return data;
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg:
            error.response.data.error.errors.$values[0] ||
            "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
          resultType: "error",
          btnText1: "Listeye Dön",
        })
      );
      return thunkApi.rejectWithValue(error);
    }
  }
);


export const piyasaBilgisiGetir = createAsyncThunk( "uyelerAraclar/piyasaBilgisiGetir", async (id, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/User/PiyasaBilgisiGetirById?id=${id}`);
      return data;
    } catch (error) {
      //! burada hata verse bile aşagıdaki modal a yönlendir.
      // thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin" ,resultType: "error", btnText1: "Listeye Dön"}))
      return thunkApi.rejectWithValue({ userId: id });
    }
  }
);


export const getAracYetkiBelgesiSorgu = createAsyncThunk( "uyelerAraclar/getAracYetkiBelgesiSorgu", async (plaka, thunkApi) => {
    try {

      const { data } = await axiosInstance.get(`/TruckTrailer/AracYetkiBelgesiSorgula?Plaka=${plaka}`);
      if (data.statusCode === 200) {
          thunkApi.dispatch(showModal("araclarYetkiBelgesiResult"));
        }
      return data
    } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: error?.response?.data?.error?.errors?.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const getAracMuayeneSorgu = createAsyncThunk("uyelerAraclar/getAracMuayeneSorgu",async (plaka, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/AracMuayeneSorgula?Plaka=${plaka}`);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("araclarMuayeneResult"));
    }
    
    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("resultErrAracMuayene"));
    thunkApi.dispatch(
      setResultModalData({
        msg: {
          text: "plakalı aracın  fenni muayene bilgisi bulunamadı! Bunun olası sebepleri;",
          arr: [
            "Araç herhangi bir yetki belgesinde kayıtlı değil ise buradan sorgulanmamaktadır.",
            "Yetki belgesinde kayıtlı olmasına rağmen fenni muayene bilgisi bulunamadıysa, muayene süresi geçmiş demektir.",
          ],
          plaka,
        },
      })
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

export const getAracCezaSorgu = createAsyncThunk( "uyelerAraclar/getAracCezaSorgu", async (plaka, thunkApi) => {
  try {

    const { data } = await axiosInstance.get(`/TruckTrailer/CezaSorgula?Plaka=${plaka}`);
    return { ...data, plaka };
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(
      setResultModalData({
        msg:
          error.response.data.error.errors.$values[0] ||
          "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
        resultType: "error",
        btnText1: "Listeye Dön",
      })
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

//! kooperatif üye ekleme
export const addKooperatifMember = createAsyncThunk("uyelerAraclar/addKooperatifMember",async (newUye, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.post(`/Auth/AddKooperatifMember`,newUye);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Üye ekleme işlemi başarı ile gerçekleştirildi.",
          resultType: "success",
          btnText1: "Listeyi Görüntüle",
        })
      );
    }

    return data.data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({msg:error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin",  resultType: "error",  btnText1: "Listeyi Görüntüle",})
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

//! kooperatif üye get
export const getCoopMembers = createAsyncThunk("uyelerAraclar/getCoopMembers",async ({ currentPage, adSoyadUnvan, IlIlce = "", tcNo, phoneNumber} ,thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/User/KooperatifMembers?SayfaSayisi=${currentPage}&&AdSoyadUnvan=${adSoyadUnvan}&&IlceIl=${IlIlce}&&tcNo=${tcNo}&&phoneNumber=${phoneNumber}`);
    
    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);
//! kooperatif üye update
export const updateCoopMember = createAsyncThunk("uyelerAraclar/updateCoopMember", async (updatedData, thunkApi) => {
  try {
    const { data } = await axiosInstance.post(`/User/UpdateKooperatifUye`, updatedData);
    if (data.statusCode === 200 && data.data) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Üye güncelleme işlemi başarıyla gerçekleştirildi", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    if(!data.data){
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({msg: data.message || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(
      setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",btnText1: "Listeyi Görüntüle",})
    );
    return thunkApi.rejectWithValue(error);
  }
}
);
//! kooperatif üye excel get
export const getCoopTopluUyeExcel = createAsyncThunk("uyelerAraclar/getCoopTopluUyeExcel", async(_, thunkApi)=> {
  try {
      
      const {data} = await axiosInstance.get(`/User/GetPanelKooperatifUsersExcel`)

      const link = document.createElement('a');
      link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
      document.body.appendChild(link)
      link.click();
      document.body.removeChild(link)

      return data.data
  } catch (error) {
      thunkApi.dispatch(setResultModalData({msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle"}))
      return thunkApi.rejectWithValue(error)
  }
})
//! kooperatif toplu excel üye ekleme
export const coopAddTopluUye = createAsyncThunk("uyelerAraclar/coopAddTopluUye",async (excel, thunkApi) => {
  try {
    
    const file = new FormData();
    file.append("file", excel);
    const { data } = await axiosInstance.post( `/Auth/AddUserKooperatifFromClientToplu`, file);
    if (data.statusCode === 200 && data.data.$values.filter(item => !item.isAdded).length === 0) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Toplu üye ekleme işlemi başarı ile gerçekleştirildi.",
          resultType: "success",
          btnText1: "Listeyi Görüntüle",
        })
      );
    }
    if(data.statusCode === 200 && data.data.$values.filter(item => !item.isAdded).length > 0){
      thunkApi.dispatch(setTopluUyeEkleMessageListCoop(data.data.$values.filter(item => !item.isAdded)))
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(setResultModalData({ msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin",  resultType: "error",  btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue(error);
  }
}
);

export const coopUpdateUyeDoc = createAsyncThunk("uyelerAraclar/coopUpdateUyeDoc", async(updatedUyeDoc, thunkApi) => {
  try {

    const file = new FormData();
    file.append("UserName", updatedUyeDoc.userName);
    file.append("DocumentType", updatedUyeDoc.documentType);
    file.append("FormFile", updatedUyeDoc.imageFile);
    const { data } = await axiosInstance.post(`/User/UploadDocToUser`, file);
    if(data.statusCode === 200){
      // thunkApi.dispatch(showModal(null))
    }
    return data.data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
})

//! kooperatif araç get
// GetAllKooperatifTruckAndTrailer
export const getAllTruckAndTrailerCoop = createAsyncThunk("uyelerAraclar/getAllTruckAndTrailerCoop",async ({ currentPage, plaka, phoneNumber, aktifPasif, adSoyadUnvan }, thunkApi) => {
  try {
    
    const { data } = await axiosInstance.get(`/TruckTrailer/GetAllKooperatifTruckAndTrailer?Plaka=${plaka}&CurrentPage=${currentPage}&PhoneNumber=${phoneNumber}&AdSoyadUnvan=${adSoyadUnvan}`);
    
    return data;
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
}
);


//! tekli araç ekleme
export const addCoopTruckSingle = createAsyncThunk("uyelerAraclar/addCoopTruckSingle", async (param, thunkApi) => {
  try {
    const { data } = await axiosInstance.post( `/TruckTrailer/AddKooperatifTruckTrailerFromClientTekli`, param);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ msg: error.response.data.ErrorDto.Errors[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
    return thunkApi.rejectWithValue(error);
  }
}
);

//! admin araclar update araç
export const coopAraclarAracUpdate = createAsyncThunk("uyelerAraclar/coopAraclarAracUpdate", async(body, thunkApi) => {
  try {

    const { data } = await axiosInstance.post(`/TruckTrailer/UpdateKooperatifTasit`, body);
    if(data.statusCode === 200){
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç güncelleme işlemi başarıyla gerçekleştirildi", resultType: "success", btnText1: "Listeyi Görüntüle"}));
    }
    return data.data;
  } catch (error) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: error.response.data.ErrorDto.Errors[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error", btnText1: "Listeyi Görüntüle",}));
      return thunkApi.rejectWithValue(error);
  }
})

//! admin araçalr get excel
export const getCoopAraclarToExcel = createAsyncThunk("uyelerAraclar/getCoopAraclarToExcel", async (_, thunkApi) => {
  try {
    const { data } = await axiosInstance.get(`/TruckTrailer/GetKooperatifTruckAndTrailerToExcel`);

    const link = document.createElement('a');
    link.href = `${process.env.REACT_APP_API_EXCEL_FILES_URI}${data.data.data}`;
    document.body.appendChild(link)
    link.click();
    document.body.removeChild(link)

    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
    return thunkApi.rejectWithValue(error);
  }
});

//! admin araclar toplu araç ekle
export const coopAraclarTopluAracEkle = createAsyncThunk("admin2/coopAraclarTopluAracEkle", async(excel, thunkApi) => {
  try {

    const file = new FormData();
    file.append("file", excel);

    const { data } = await axiosInstance.post(`/truckTrailer/AddKooperatifTruckTrailerFromClientToplu`, file);

    if (data.statusCode === 200 && data?.data?.$values.filter(item => !item.isAdded).length === 0) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(setResultModalData({ msg: "Araç ekleme işlemi başarı ile gerçekleştirildi.", resultType: "success", btnText1: "Listeyi Görüntüle",}));
    }
    if (data.statusCode === 200 && data?.data?.$values.filter(item => !item.isAdded).length > 0) {
      thunkApi.dispatch(setTopluAracEklemeHatalar(data?.data?.$values.filter(item => !item.isAdded)))
    }
    
    return data.data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({ 
      msg: error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", 
      resultType: "error", 
      btnText1: "Listeye Dön",
    }));
    return thunkApi.rejectWithValue(error);
  }
})

//! admin araçlar araç belgesi güncelle 
export const coopUpdateDocumentTruck = createAsyncThunk("uyelerAraclar/coopUpdateDocumentTruck",async (updatedTruckDoc, thunkApi) => {
  try {
    const file = new FormData();
    file.append("UserName", updatedTruckDoc.userName);
    file.append("DocumentType", updatedTruckDoc.documentType);
    file.append("FormFile", updatedTruckDoc.imageFile);
    const { data } = await axiosInstance.post(`/TruckTrailer/UploadDocToTruck`, file);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Araç Belgesi başarıyla güncellendi",
          resultType: "success",
          btnText1: "Geri Dön",
        })
      );
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(setResultModalData({msg:error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin", resultType: "error",  btnText1: "Listeye Dön",})
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

//! admin araçlar dorse belgesi güncelle 
export const coopUpdateDocumentTrailer = createAsyncThunk("uyelerAraclar/coopUpdateDocumentTrailer", async (updatedTrailerDoc, thunkApi) => {
  try {
    const file = new FormData();
    file.append("UserName", updatedTrailerDoc.userName);
    file.append("DocumentType", updatedTrailerDoc.documentType);
    file.append("FormFile", updatedTrailerDoc.imageFile);

    const { data } = await axiosInstance.post(`/TruckTrailer/UploadPhotoToTrailer`, file);
    if (data.statusCode === 200) {
      thunkApi.dispatch(showModal("result"));
      thunkApi.dispatch(
        setResultModalData({
          msg: "Araç Belgesi başarıyla güncellendi",
          resultType: "success",
          btnText1: "Geri Dön",
        })
      );
    }
    return data;
  } catch (error) {
    thunkApi.dispatch(showModal("result"));
    thunkApi.dispatch(
      setResultModalData({
        msg:error.response.data.error.errors.$values[0] || "Bir hata oluştu, lütfen daha sonra tekrar deneyin",
        resultType: "error",
        btnText1: "Listeye Dön",
      })
    );
    return thunkApi.rejectWithValue(error);
  }
}
);

const uyelerAraclarSlice = createSlice({
  name: "uyelerAraclar",
  initialState,
  reducers: {
    getUyeItemData: (state, action) => {
      state.uyeItemData = action.payload;
    },

    getAracItemData: (state, action) => {
      state.aracItemData = action.payload;
    },

    setTopluUyeEkleMessageListCoop: (state, action) => {
      state.responseMessageList = action.payload
    },

    setTopluAracEklemeHatalar: (state, action) => {
      state.topluAracEklemeHatalar = action.payload
    },

    clearTopluUyeEkleMessageListCoop: (state, action) => {
      state.responseMessageList = []
    },

    clearUyelerAraclarSlice: (state) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder

      // get uyeler mesleki yterlilik
      .addCase(getUyeMeslekiYeterlilik.pending, (state) => {
        state.isLoadingGetUyeMeslekiYeterlilik = true;
        state.uyeMeslekiYeterlilik = null;
      })

      .addCase(getUyeMeslekiYeterlilik.fulfilled, (state, action) => {
        state.isLoadingGetUyeMeslekiYeterlilik = false;
        state.uyeMeslekiYeterlilik = action.payload.data.$values;
      })

      .addCase(getUyeMeslekiYeterlilik.rejected, (state, action) => {
        state.isLoadingGetUyeMeslekiYeterlilik = false;
        state.isError = true;
      })

      // get uyenin bagli oldugu uyeler
      .addCase(getUyeninBagliOlduguUyeler.pending, (state) => {
        state.isLoadingGetUyeninBagliOlduguUyeler = true;
        state.uyeMeslekiYeterlilik = null;
        state.uyeIsvereni = null;
      })

      .addCase(getUyeninBagliOlduguUyeler.fulfilled, (state, action) => {
        state.isLoadingGetUyeninBagliOlduguUyeler = false;
        state.uyeIsvereni = action.payload.data.$values;
      })

      .addCase(getUyeninBagliOlduguUyeler.rejected, (state, action) => {
        state.isLoadingGetUyeninBagliOlduguUyeler = false;
        state.isError = true;
      })

      // piyasa bilgisi getir
      .addCase(piyasaBilgisiGetir.pending, (state) => {
        state.isLoadingPiyasaBilgisiGetir = true;
      })

      .addCase(piyasaBilgisiGetir.fulfilled, (state, action) => {
        state.isLoadingPiyasaBilgisiGetir = false;
        state.uyePiyasaBilgisi = action.payload.data;
      })

      .addCase(piyasaBilgisiGetir.rejected, (state, action) => {
        state.uyePiyasaBilgisi = action.payload;
        state.isLoadingPiyasaBilgisiGetir = false;
      })


      // get arac yetki belge sorgu
      .addCase(getAracYetkiBelgesiSorgu.pending, (state) => {
        state.isLoadingGetAracYetkiSorgu = true;
        state.aracYetkiBelgeSorgu = null;
      })

      .addCase(getAracYetkiBelgesiSorgu.fulfilled, (state, action) => {
        state.isLoadingGetAracYetkiSorgu = false;
        state.yetkiBelgesiBilgi = action.payload.data;
      })

      .addCase(getAracYetkiBelgesiSorgu.rejected, (state, action) => {
        state.isLoadingGetAracYetkiSorgu = false;
      })

      // get arac ceza sorgu
      .addCase(getAracCezaSorgu.pending, (state) => {
        state.isLoadingGetAracCezaSorgu = true;
        state.aracCezaSorgu = null;
      })

      .addCase(getAracCezaSorgu.fulfilled, (state, action) => {
        state.isLoadingGetAracCezaSorgu = false;
        state.aracCezaSorgu = action.payload;
      })

      .addCase(getAracCezaSorgu.rejected, (state, action) => {
        state.isLoadingGetAracCezaSorgu = false;
      })

      // get arac muayene sorgu
      .addCase(getAracMuayeneSorgu.pending, (state) => {
        state.isLoadingGetAracMuayeneSorgu = true;
        state.aracMuayeneSorgu = null;
      })

      .addCase(getAracMuayeneSorgu.fulfilled, (state, action) => {
        state.isLoadingGetAracMuayeneSorgu = false;
        state.muayeneBilgi = action.payload.data;
      })

      .addCase(getAracMuayeneSorgu.rejected, (state, action) => {
        state.isLoadingGetAracMuayeneSorgu = false;
      })

      
      .addCase(addKooperatifMember.pending, (state) => {
        state.isLoadingAddCoop = true;
      })

      .addCase(addKooperatifMember.fulfilled, (state, action) => {
        state.isLoadingAddCoop = false;
        state.coopMemberList = [...state.coopMemberList, {...action.payload, ehliyetTypes: action.payload?.ehliyetTypes?.$values, srcTypes: action.payload?.srcTypes?.$values}]
      })

      .addCase(addKooperatifMember.rejected, (state, action) => {
        state.isLoadingAddCoop = false;
        state.isErrorAddCoop = true
      })

      .addCase(getCoopMembers.pending, (state) => {
        state.isLoadingGetCoop = true;
      })

      .addCase(getCoopMembers.fulfilled, (state, action) => {
        state.isLoadingGetCoop = false;
        state.coopMemberList = action.payload.musteriListesi.$values.map((item) => {
          return {
            ...item,
            ehliyetTypes: item?.ehliyetTypes?.$values,
            srcTypes: item?.srcTypes?.$values
          }
        })
        state.coopMemberListCount = action.payload.count
      })

      .addCase(getCoopMembers.rejected, (state, action) => {
        state.isLoadingGetCoop = false;
        state.isErrorGetCoop = true
      })

       //! admin üye güncelleme
     .addCase(updateCoopMember.pending, (state) => {
      state.isLoadingUpdateCoop = true
    })
    .addCase(updateCoopMember.fulfilled, (state, action)=> {
      state.isLoadingUpdateCoop = false
      const {data} = action.payload
      state.coopMemberList = state.coopMemberList.map((item) => {
        if(item.id === data.id){
          return {
            ...data,
            ehliyetTypes: data.ehliyetTypes.$values,
            srcTypes: data.srcTypes.$values,
          }
        }
        else{
          return item
        }
      })
    })
    .addCase(updateCoopMember.rejected, (state, action)=> {
        state.isLoadingUpdateCoop = false
        state.isErrorUpdateCoop = true
    })

    
    .addCase(getCoopTopluUyeExcel.pending, (state) => {
      state.isLoadingGetCoopExcel = true;
    })

    .addCase(getCoopTopluUyeExcel.fulfilled, (state, action) => {
      state.isLoadingGetCoopExcel = false;
    })

    .addCase(getCoopTopluUyeExcel.rejected, (state, action) => {
      state.isLoadingGetCoopExcel = false;
      state.isErrorGetCoop = true
    })

    
    //! coopAddTopluUye
    .addCase(coopAddTopluUye.pending, (state) => {
      state.isLoadingAddCoopExcel = true;
    })
    .addCase(coopAddTopluUye.fulfilled, (state, action) => {
      state.isLoadingAddCoopExcel = false;
      const newAddedList = action.payload.data.$values.filter(item => item.isAdded).map(item => item.items) 
      state.coopMemberList = [...state.coopMemberList, ...newAddedList]
    })
    .addCase(coopAddTopluUye.rejected, (state, action) => {
      state.isLoadingAddCoopExcel = false;
    })

    
    .addCase(coopUpdateUyeDoc.pending, (state) => {
      state.isLoadingUyeDoc = true;
      state.isSuccessUyeDoc = false

    })

    .addCase(coopUpdateUyeDoc.fulfilled, (state, action) => {
      state.isLoadingUyeDoc = false;
      state.uyeItemData = {...state.uyeItemData, ...action.payload}
      state.isSuccessUyeDoc = true

    })

    .addCase(coopUpdateUyeDoc.rejected, (state, action) => {
      state.isLoadingUyeDoc = false;
      state.isSuccessUyeDoc = false

    })

    //! tekli araç get
    .addCase(getAllTruckAndTrailerCoop.pending, (state) => {
      state.isLoadingGetArac = true;
    })
    .addCase(getAllTruckAndTrailerCoop.fulfilled, (state, action) => {
      state.isLoadingGetArac = false;
      state.coopAracListCount = action.payload.data.count
      state.coopAracList = action.payload.data?.truckAndTrailers.$values;
    })
    .addCase(getAllTruckAndTrailerCoop.rejected, (state, action) => {
      state.isLoadingGetArac = false;
    })

    //! tekli araç ekleme
    .addCase(addCoopTruckSingle.pending, (state) => {
      state.isLoadingAddAdminTruckSingle = true;
    })
    .addCase(addCoopTruckSingle.fulfilled, (state, action) => {
      state.isLoadingAddAdminTruckSingle = false;
      state.coopAracList = [
        ...state.coopAracList,
        action.payload.data,
      ];
    })
    .addCase(addCoopTruckSingle.rejected, (state, action) => {
      state.isLoadingAddAdminTruckSingle = false;
    })

    //! araçlar update
    .addCase(coopAraclarAracUpdate.pending, (state) => {
      state.isLoadingUpdateCoop = true;
    })
    .addCase(coopAraclarAracUpdate.fulfilled, (state, action) => {
      state.isLoadingUpdateCoop = false;
      state.coopAracList = state.coopAracList.map((item) => {
        if(item?.id === action.payload?.id){
          return action.payload
        }
        else{
          return item
        }
      })
    })
  
    .addCase(coopAraclarAracUpdate.rejected, (state) => {
      state.isLoadingUpdateCoop = false;
    })

    //! araçlar get excel
    .addCase(getCoopAraclarToExcel.pending, (state) => {
      state.isLoadingGetCoopExcel = true;
    })
    .addCase(getCoopAraclarToExcel.fulfilled, (state) => {
      state.isLoadingGetCoopExcel = false;
    })
    .addCase(getCoopAraclarToExcel.rejected, (state) => {
      state.isLoadingGetCoopExcel = false;
    })

    //! araçlar post excel
    .addCase(coopAraclarTopluAracEkle.pending, (state) => {
      state.isLoadingAddAdminTruckSingle = true;
    })
    .addCase(coopAraclarTopluAracEkle.fulfilled, (state, action) => {
      state.isLoadingAddAdminTruckSingle = false;
      state.coopAracList = [...state.coopAracList, ...action.payload.$values]
    })
    .addCase(coopAraclarTopluAracEkle.rejected, (state) => {
      state.isLoadingAddAdminTruckSingle = false;
    })
  },
});

export const { getUyeItemData, getAracItemData, clearUyelerAraclarSlice, setTopluUyeEkleMessageListCoop, clearTopluUyeEkleMessageListCoop, setTopluAracEklemeHatalar } = uyelerAraclarSlice.actions;
export default uyelerAraclarSlice.reducer;
